import React from "react";
import Header from "./Header/Header";
import "./style.scss"
import Home from "./Home/Home";
import { Route, Routes } from "react-router-dom";
import About from "./About/About";
import Contact from "./Contact/Contact";

function App() {
  return (
    <div className="App">
     <Header/>
     <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/about" element={<About/>}/>
      <Route path="/contact" element={<Contact/>}/>
     </Routes>
    </div>
  );
}

export default App;
